import { ReactNode } from 'react';
import { css } from '@emotion/react';

import { mediaQueries } from '@zapier/identity-utils';
import { Colors, Typography } from '@zapier/design-system';

type FeatureItemListProps = {
  children: ReactNode;
  description?: string;
  title?: string;

  /**
   * Controls the maximum number of <FeatureItem> elements that will be visible at mobile breakpoints.
   * Defaults to `0`.
   */
  maxMobileItems?: number;
};

const listStyles = (maxMobileItems: number) => {
  return css`
    margin-bottom: 20px;
    ${maxMobileItems === 0 ? 'display: none;' : ''}

    li:nth-of-type(n + ${maxMobileItems + 1}) {
      display: none;
    }

    ${mediaQueries.tablet} {
      display: grid;
      gap: 20px;

      li:nth-of-type(n + ${maxMobileItems + 1}) {
        display: flex;
      }
    }

    ${mediaQueries.desktop} {
      gap: 10px;
    }
  `;
};

const titleStyles = css`
  ${Typography.PageHeader}
  color: ${Colors.GrayWarm10};
  margin-bottom: 30px;
  margin-top: 30px;
  text-align: left;

  ${mediaQueries.tablet} {
    padding-right: 50px;
  }

  ${mediaQueries.desktop} {
    ${Typography.PageHeader}
  }
`;

const descriptionStyle = css`
  ${Typography.Body1}
  color: ${Colors.GrayWarm9};
  margin-bottom: 30px;
  text-align: left;

  ${mediaQueries.tablet} {
    padding-right: 50px;
  }

  ${mediaQueries.desktop} {
    ${Typography.Body1}
  }
`;

export function FeatureItemList({
  children,
  description,
  title,
  maxMobileItems = 0,
}: FeatureItemListProps) {
  return (
    <div>
      {title && <h1 css={titleStyles}>{title}</h1>}
      {description && <p css={descriptionStyle}>{description}</p>}
      <ul css={[listStyles(maxMobileItems)]}>{children}</ul>
    </div>
  );
}
